<template>
  <path
    d="M39.4848 16.077C39.4848 8.85476 33.63 3 26.4078 3C19.1856 3 13.3308 8.85476 13.3308 16.077V37.0001C13.3308 44.2223 19.1856 50.0771 26.4078 50.0771C33.63 50.0771 39.4848 44.2223 39.4848 37.0001V16.077Z"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M26.4078 60.5386V71.0001"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M49.8156 39.6157C49.137 45.3473 46.3792 50.6307 42.0648 54.4645C37.7504 58.2982 32.1794 60.4158 26.4078 60.4158C20.6362 60.4158 15.0651 58.2982 10.7508 54.4645C6.43639 50.6307 3.67854 45.3473 3 39.6157"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>

<script>
export default {
   props: {
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    iconBorder: {
      type: String,
      required: false,
      default: 'black',
    },
  },   
};
</script>

<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);
        stroke:var(--iconColor)
    }
    .group:hover .group-hover\:text-hoverIcon path{
      stroke:var(--iconHoberColor)
    }
</style>